import React from "react";
import PropTypes from "prop-types";
import MCard from "components/Shared/MCard.tsx";

const OrderSummary = props => {

  const getPriceContent = () => {
    if (props.minPrice && props.maxPrice){
      return (
        <div className="order-summary-min-max">
          <div>Minimum:</div>
          <div>{`$${parseFloat(props.minPrice).toFixed(2)}`}</div>
          <div>Maximum:</div>
          <div>{`$${parseFloat(props.maxPrice).toFixed(2)}`}</div>
        </div>
      );
    }
    return (
      <>
        <div className="order-summary-min">
            <div>{props.hasRetailOrdering ? "Price" : "Expected Price"}:</div>
            <div>{`$${parseFloat(props.minPrice).toFixed(2)}`}</div>
        </div>
        <div className="order-summary-disclaimer">{"Expected price includes the base report and form fees. This is an estimate and the price may be adjusted by Mueller reports due to geographical variables or additional supplemental form requests."}</div>
      </>
    );
  };

  // Styles used here are in WebOrderV2.scss
  return (
    <MCard
      title="Order Summary"
    >
      <div className="order-summary-container">
        {getPriceContent()}
        {props.creditCardAvailable &&
          <p>Credit card billing available</p>
        }
      </div>
    </MCard>
  );
};

OrderSummary.propTypes = {
  minPrice: PropTypes.string, // If only 1 price, provide as minPrice
  maxPrice: PropTypes.string,
  creditCardAvailable: PropTypes.bool,
  hasRetailOrdering: PropTypes.bool,
};

export default OrderSummary;